
import { defineComponent, ref, PropType } from "vue";
import useStatus from "./useStatus";
import { StatusItem } from "@/types";

export default defineComponent({
  name: "TableItem",
  props: {
    server: {
      type: Object as PropType<StatusItem>,
      default: () => ({}),
    },
  },
  setup(props) {
    const collapsed = ref(true);
    const utils = useStatus(props);
    return {
      collapsed,
      ...utils,
    };
  },
});
